import { Link } from "react-router-dom";
import { Lock } from "lucide-react";

export const LockedPanel = ({
  title = "Locked in the free preview",
  body = "Your free preview covers Orientation and Service Guidelines. Founding member access unlocks the rest of the roadmap, the Recipe Vault, Event Prep and the Resource Vault.",
  testId = "locked-panel",
}) => (
  <div
    data-testid={testId}
    className="relative overflow-hidden border border-primary/40 bg-[#191603] p-8 text-center md:p-14"
  >
    <Lock className="mx-auto text-primary" size={26} />
    <h3 className="display neon mt-5 text-3xl uppercase md:text-4xl">{title}</h3>
    <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-muted-foreground">{body}</p>
    <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
      <Link
        to="/buy/popup_profits"
        data-testid={`${testId}-unlock`}
        className="display inline-flex rounded-sm bg-primary px-6 py-3 text-lg uppercase text-primary-foreground transition-colors hover:bg-[#E6C800]"
      >
        Unlock Smash Academy — $67
      </Link>
      <Link
        to="/start"
        data-testid={`${testId}-pricing`}
        className="mono text-[11px] tracking-widest text-muted-foreground hover:text-primary"
      >
        SEE ALL OPTIONS →
      </Link>
    </div>
  </div>
);

export const FreePreviewBanner = () => (
  <div
    data-testid="free-preview-banner"
    className="mt-8 flex flex-wrap items-center justify-between gap-4 border border-primary/40 bg-[#191603] px-5 py-4"
  >
    <div>
      <div className="mono text-[10px] tracking-[0.3em] text-primary">FREE PREVIEW</div>
      <p className="mt-1 text-sm text-muted-foreground">
        Milestones 1 and 2 are fully open. Founding member access unlocks the other seven, the
        vaults and Event Prep.
      </p>
    </div>
    <Link
      to="/buy/popup_profits"
      data-testid="preview-unlock-cta"
      className="display shrink-0 rounded-sm bg-primary px-5 py-2.5 text-lg uppercase text-primary-foreground transition-colors hover:bg-[#E6C800]"
    >
      Unlock — $67
    </Link>
  </div>
);

/** Shown once a free operator finishes the free preview milestones. */
export const JourneyStartedPanel = () => (
  <div
    data-testid="journey-started"
    className="relative mt-8 overflow-hidden border border-primary bg-[#191603] p-7 md:p-10"
  >
    <div className="mono text-[10px] tracking-[0.35em] text-primary">FREE PREVIEW COMPLETE</div>
    <h2 className="neon mt-3 text-4xl leading-tight sm:text-5xl">
      Your Smash journey has started.
    </h2>
    <p className="mt-4 max-w-2xl text-base text-muted-foreground md:text-lg">
      You've completed the first step. Unlock the complete roadmap and continue building your
      pop-up.
    </p>
    <Link
      to="/buy/popup_profits"
      data-testid="journey-continue-cta"
      className="display mt-8 inline-flex rounded-sm bg-primary px-7 py-4 text-xl uppercase text-primary-foreground transition-colors hover:bg-[#E6C800] md:text-2xl"
    >
      Continue my journey — $67
    </Link>
    <p className="mono mt-6 text-[11px] leading-relaxed text-muted-foreground">
      FOUNDING PRICE. ACADEMY PRICING MAY INCREASE AS CURRICULUM, RESOURCES, COMMUNITY AND SUPPORT
      EXPAND.
    </p>
  </div>
);
